import moment from 'dayjs';

const formatDate = function(
  timestamp: number,
  timezoneOffset: number,
  pattern = 'DD/MM/YYYY HH:mm:ss'
) {
  const dataDate = new Date(timestamp);
  const date = getLocalTime(timezoneOffset, dataDate);
  return moment(date).format(pattern);
};


const formatDates = function (dateString){
  if (!dateString) return '';
  let date;
  if (dateString.includes(' ')) {
    const datePart = dateString.split(' ')[0];
    date = new Date(datePart);
  } else {
    date = new Date(dateString);
  }
  if (isNaN(date.getTime())) return '';

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');

  return `${month}-${day}`;
};


const getLocalTime = function(i, t) {
  const localTime = new Date(t);
  const len = localTime.getTime();
  const offset = localTime.getTimezoneOffset() * 60000;
  const utcTime = len + offset;
  return new Date(utcTime + 3600000 * i);
};


const formatDateInLocale = function(timestamp: number,timezoneOffset: number ) {
  const newDate = new Date(
    formatDate(timestamp, timezoneOffset, 'YYYY-MM-DD')
  );
  const day = newDate
    .getDate()
    .toString()
    .padStart(2, '0');
  const shortMonth = newDate.toLocaleDateString('en-US', {
    month: 'short'
  });
  const fullYear = newDate.getFullYear().toString();
  return `${day} ${shortMonth} ${fullYear}`;
};

const convertTimestampWithOffset = (timestamp, timezoneoffset) => {
  const offsetInMilliseconds = timezoneoffset * 60 * 60 * 1000;

  return timestamp + offsetInMilliseconds;
};

const formatedDates = function(date) {
  return moment(date).format('DDMMYYYYHHmmss');
};

export { formatDate, formatDateInLocale, convertTimestampWithOffset, formatedDates, formatDates };
